import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import AddBoxOutlinedIcon from '@mui/icons-material/AddBoxOutlined';
import ButtonBase from '@mui/material/ButtonBase';

// The picker only. Sending the files, and showing how far along they are, is
// useFileUploads and UploadProgress, so the progress can sit somewhere wider
// than this icon.
export default function FileUpload({ onFiles }) {
    const handleCapture = ({ target }) => {
        const files = [...target.files];
        // Reset the input so selecting the same file again re-fires onChange.
        target.value = '';
        if (files.length && onFiles) onFiles(files);
    };

    return (
        <ButtonBase
            style={{
                borderRadius: '50%'
            }}>
            <input
                accept='image/*,.pdf,.doc,.docx,.ppt,.pptx,.xls,.xlsx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                style={{ display: 'none' }}
                id='fileUpload'
                onChange={handleCapture}
                multiple
                type='file'
            />
            <label htmlFor='fileUpload' style={{ display: 'block', padding: 0, margin: 0 }}>
                <Tooltip title='Add New Slide'>
                    <AddBoxOutlinedIcon style={{ display: 'block', padding: 0, margin: 0 }} />
                </Tooltip>
            </label>
        </ButtonBase>
    );
}
